import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from 'src/app/classes/utility';

@Component({
  selector: 'app-reviews',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './reviews.component.html',
  styleUrl: './reviews.component.scss',
})
export class ReviewsComponent implements OnChanges {
  @Input() product!: Product;
  _content: any;
  constructor() {}
  count = 105;
  stars = [1, 2, 3, 4, 5];

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (this.product.metafields?.okendo?.summaryData) {
        const okendo = JSON.parse(this.product.metafields.okendo.summaryData);
        this.count = okendo.reviewCount;
        this.stars = new Array(
          Math.floor(parseFloat(okendo.reviewAverageValue))
        );
      }
    } catch (e) {
      console.log(e);
    }
  }
}
